import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ANALYTICS_SECTIONS } from "@/api/types";
import { AnalyticsPage } from "@/features/analytics/analytics-page";

export const Route = createFileRoute("/_authenticated/analytics/")({
  validateSearch: z.object({
    section: z.enum(ANALYTICS_SECTIONS).optional().catch(undefined),
    range: z.enum(["24h", "7d", "30d", "90d"]).optional().catch(undefined),
  }),
  head: () => ({ meta: [{ title: "Analytics · Rogue Admin" }] }),
  component: AnalyticsPage,
});
